import { EventBroker } from "../../../lib/utils/event-broker";

export const EVENTS = {
  INIT: 'INIT',
  SAVE: 'SAVE',
  CLOSE: 'CLOSE',
}

export const backgroundThemeImageSettingsEventBroker = new EventBroker();
